import { createDomainApi, type ExtractEntityType } from '@skylabs-digital/react-proto-kit';
import { notificationSchema } from '../schemas/notification.schema';

export const notificationsApi = createDomainApi('notifications', notificationSchema);

export type NotificationEntity = ExtractEntityType<typeof notificationsApi>;
